import React from 'react';
import './article.css';

const Article = ({ imgUrl, date, text, text2 }) => (
  <div className="protactics__blog-container_article">
    <div className="protactics__blog-container_article-image">
      <img src={imgUrl} alt="blog_image" />
    </div>
    <div className="protactics__blog-container_article-content">
      <div>
        <h2>{date}</h2>
        <br/>
        <h3>{text}</h3>
        <h3>{text2}</h3>        
      </div>
    </div>
  </div>
);

export default Article;
